import { useEffect } from "react";
import { actionCreators, State } from "../../state";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { getAirlines } from "../../service/TDXService";
import type { Airline } from "../../my-type";

export const useGetAirlines = () => {
  const dispatch = useDispatch();
  const { updateAirlines } = bindActionCreators(actionCreators, dispatch);

  const airlines: Airline[] = useSelector((state: State) => state.airlines);

  let isLoading: boolean = false;

  useEffect(() => {

    const retrieveData = async () => {
      isLoading = true;
      let airlineList = await getAirlines();
      if (airlineList != null) {
        updateAirlines(airlineList);
      }
      isLoading = false;
    }

    if (airlines.length === 0 && !isLoading) {
      console.log('retrieving airlines...');
      retrieveData();
    } else {
      //console.log(suppliers);
      //console.log('supplier data cached.');
    }
  }, [airlines, updateAirlines])

  const refresh = async () => {
    updateAirlines([]);
  }

  return {
    airlines,
    refresh,
  };
};
